/**
 * @generated SignedSource<<52fc2a2119be8df3a1d1c297048b1428>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersGetPodcastTitlePodcast$data = {
  readonly __typename: "Podcast";
  readonly " $fragmentType": "helpersGetPodcastTitlePodcast";
};
export type helpersGetPodcastTitlePodcast$key = {
  readonly " $data"?: helpersGetPodcastTitlePodcast$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersGetPodcastTitlePodcast">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersGetPodcastTitlePodcast"
};

(node as any).hash = "b76a153ed0eaca688b83539b9481daf6";

export default node;
